export default function TableRenderer({ section }){

    return(

        <table className="table">

            <tbody>

            {Object.entries(section.value || {}).map(([k,v])=>(

                <tr key={k}>

                    <td><b>{k}</b></td>

                    <td>{v}</td>

                </tr>

            ))}

            </tbody>

        </table>

    );

}